import { reactive } from 'vue';

export const criarEstabelecimentoFor = () => {
    return reactive({
        id: 0,
        idestabelecimento: 0,
        nmfornecedor: '',
        cpfcnpj: '',
        sif_origem: '',
        nmmunicipio: '',
        uf: '',
        ativo: 'S',
        idlogin: 0
    });
};